// React contexts shared across user routes.

import { createContext, useContext } from "react";
import type { UserSyncState } from "./hooks/useUserSync";

export interface AppAuth {
  /** The learner's userId (docId in /users). */
  userId: string;
  /** True when this session is a worker (role:"worker" or ?preview=true).
   *  Used to reveal the testOnly「測試用地圖」on the learner app. */
  isWorker: boolean;
  /** Which event cohort this learner belongs to, e.g. "2025" / "2026". */
  cohortId: string;
}

export const AppAuthContext = createContext<AppAuth | null>(null);

export function useAppAuth(): AppAuth {
  const v = useContext(AppAuthContext);
  if (!v) throw new Error("AppAuthContext missing — wrap in <AuthGate>.");
  return v;
}

export const AppSyncContext = createContext<UserSyncState | null>(null);

export function useAppSync(): UserSyncState {
  const v = useContext(AppSyncContext);
  if (!v) throw new Error("AppSyncContext missing — wrap in <SyncProvider>.");
  return v;
}
